import { createSlice } from "@reduxjs/toolkit";
import { slices } from "@/constants/sliceNames";
import { Execution } from "@/entities";

import {
  requestMyExecutionsStatus,
  requestUpdateExecutionNameStatus,
  requestDeleteExecutionStatus,
  requestRerunExecutionStatus,
  requestSingleExecutionStatus,
  requestModelExecutionDetailsStatus,
} from "../../effects/executions/executions-effects";

/**
 * @type {{ executionsList: Execution[], execution: Execution, details: Object, loading: Boolean, pageCount: Number }}
 */
export const initialState = {
  executionsList: [],
  execution: new Execution(),
  details: {},
  loading: false,
  pageCount: 0,
  detailsLoading: false,
};

const executionsSlice = createSlice({
  name: slices.executions,
  initialState,
  reducers: {
    resetExecutions: (state, action) => {
      state = initialState;
    },
    resetSingleExecution: (state, action) => {
      state.execution = new Execution();
      state.details = {};
    },
    updateExecution: (state, action) => {
      state.execution = state.execution.updateExecution(action.payload);
    },
  },
  extraReducers: {
    ...requestMyExecutionsStatus,
    ...requestUpdateExecutionNameStatus,
    ...requestDeleteExecutionStatus,
    ...requestRerunExecutionStatus,
    ...requestSingleExecutionStatus,
    ...requestModelExecutionDetailsStatus,
  },
});

const { actions, reducer } = executionsSlice;

export const { resetExecutions, resetSingleExecution, updateExecution } = actions;

export default reducer;
